module.exports = __webpack_public_path__ + "img/logo.a5b50e34.png";